/**
 * ICS (iCalendar) file generator - client-side wrapper
 * Re-exports shared implementation with browser-specific download function
 */

export { generateICS } from '../../../lib/icsGenerator';
export type { ICSEvent, ICSOptions } from '../../../lib/icsGenerator';

/**
 * Download ICS content as a file (client-side only)
 */
export function downloadICS(icsContent: string, filename: string): void {
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
